import { useNavigate } from 'react-router-dom';
import { PlannedDeputatesTable } from '../../../../components/Deputate/Tables/PlannedDeputatesTable';

export const DeputateEvaluatePlannedOverviewSubpage = () => {
  const navigate = useNavigate();

  function handleNavigate(teacherUuid: string) {
    navigate(teacherUuid);
  }

  return <PlannedDeputatesTable onNavigate={handleNavigate} />;
};
